<template>
  <div class="ic-forms">
    <div v-if="!isSent">
      <ul class="nav nav-tabs nav-tabs-fix" role="tablist">
        <li role="presentation" :class="{active: group == 'Contact'}">
          <a
            role="tab"
            tabindex="-1"
            :aria-selected="group == 'Contact'"
            @click="group = 'Contact'; selected = 'k01'"
          >Formularz kontaktowy</a>
        </li>
        <li role="presentation" :class="{active: group == 'Complaint'}">
          <a
            role="tab"
            tabindex="-1"
            :aria-selected="group == 'Complaint'"
            @click="group = 'Complaint'; selected = 'r07'"
          >Formularz zgłoszeniowy</a>
        </li>
      </ul>

      <div class="tab-content form-sm-fix" v-if="group == 'Contact'">
        <div class="ptl">
          <div class="row form-group g-3  align-items-center">
            <div class="col-12">{{$t('form_contact_introtext')}}</div>
            <div class="col-auto col-md-4">{{$t('form_topic')}}</div>
            <div class="col-auto col-md-8">
              <IcSelect v-model="selected" id="form" :values="formTypeContact" :allowEmpty="false"></IcSelect>
            </div>
          </div>
          <component
            v-if="selectedComponent"
            v-bind:is="selectedComponent"
            @form:sent="sent"
            @form:error="error"
          />
        </div>
      </div>

      <div class="tab-content form-sm-fix" v-if="group == 'Complaint'">
        <div class="ptl">
          <div class="row form-group">
            <div class="col-md-12 mbm">{{$t('form_complaint_introtext')}}</div>
            <div class="col-md-4">{{$t('form_topic')}}</div>
            <div class="col-md-8">
              <IcSelect
                v-model="selected"
                id="form"
                :values="formTypeComplaint"
                :allowEmpty="false"
              ></IcSelect>
            </div>
          </div>
          <component
            v-if="selectedComponent"
            v-bind:is="selectedComponent"
            @form:sent="sent"
            @form:error="error"
          />
        </div>
      </div>
    </div>

    <IcFormsSent v-if="isSent" :data="sentData" />
  </div>
</template>
  
<script>
import IcFormsBase from "./Base/FormsBase";
import IcFormContactK01 from "./k_01.vue";
import IcFormContactK02 from "./k_02.vue";
import IcFormContactK03 from "./k_03.vue";
import IcFormContactK04 from "./k_04.vue";
import IcFormContactK05 from "./k_05.vue";
import IcFormContactK06 from "./k_06.vue";
import IcFormContactK07 from "./k_07.vue";
import IcFormContactK08 from "./k_08.vue";
import IcFormComplaintR01 from "./r_01.vue";
import IcFormComplaintR02 from "./r_02.vue";
import IcFormComplaintR03 from "./r_03.vue";
import IcFormComplaintR04 from "./r_04.vue";
import IcFormComplaintR05 from "./r_05.vue";
import IcFormComplaintR06 from "./r_06.vue";
import IcFormComplaintR07 from "./r_07.vue";
import IcFormComplaintR08 from "./r_08.vue";
import IcFormComplaintR09 from "./r_09.vue";
//import IcFormComplaintR10 from "./r_10.vue";
import { get } from "lodash";

const _ = { get };

export default {
  name: "IcForms",
  extends: IcFormsBase,
  data() {
    return {
      group: "Contact",
      selected: "",
      formType: [
        { value: "k01", name: this.$t("form_k01") },
        { value: "k02", name: this.$t("form_k02") },
        { value: "k03", name: this.$t("form_k03") },
        { value: "k04", name: this.$t("form_k04") },
        { value: "k05", name: this.$t("form_k05") },
        { value: "k06", name: this.$t("form_k06") },
        { value: "k07", name: this.$t("form_k07") },
        { value: "k08", name: this.$t("form_k08") },
        { value: "r07", name: this.$t("form_r07") },
        { value: "r01", name: this.$t("form_r01") },
        { value: "r08", name: this.$t("form_r08") },
        { value: "r02", name: this.$t("form_r02") },
        { value: "r03", name: this.$t("form_r03") },
        { value: "r04", name: this.$t("form_r04") },
        { value: "r05", name: this.$t("form_r05") },
        { value: "r09", name: this.$t("form_r09") },
        { value: "r06", name: this.$t("form_r06") },
        //{ value: "r10", name: this.$t("form_r10") },
      ]
    };
  },
  mounted() {
    let setup = typeof icVSetup !== "undefined" ? icVSetup : {};
    let selected = _.get(setup, "forms.selected");

    if (selected) {
      this.selected = selected;
      this.group = selected && selected[0] == "k" ? "Contact" : "Complaint";
    }
  },
  components: {
    IcFormContactK01,
    IcFormContactK02,
    IcFormContactK03,
    IcFormContactK04,
    IcFormContactK05,
    IcFormContactK06,
    IcFormContactK07,
    IcFormContactK08,
    IcFormComplaintR01,
    IcFormComplaintR02,
    IcFormComplaintR03,
    IcFormComplaintR04,
    IcFormComplaintR05,
    IcFormComplaintR06,
    IcFormComplaintR07,
    IcFormComplaintR08,
    IcFormComplaintR09,
    //IcFormComplaintR10
  }
};
</script>

<style lang="scss">
</style>
